import Grid from '@mui/material/Grid';
import { SubmitHandler, useForm, type Control } from 'react-hook-form';
import EmailInput from 'src/packages/polaris/components/FormElements/EmailInput';
import useIsPolaris from '../hooks/useIsPolaris';
import useTransition from '../hooks/useTransition';
import PhoneTextInput from './FormElements/PhoneTextInput';
import SubmitButton from './SubmitButton';

import type { IPolarisInterviewQuestion } from 'src/packages/polaris/types';

export interface IContactForm {
  phoneNumber: string;
  email: string;
}

export const ContactFormInputFields = ({
  control,
  required,
}: {
  control: Control<any, any>;
  required?: boolean;
}) => {
  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <PhoneTextInput
          control={control}
          label={`Phone number${required ? '*' : ''}`}
          required={required}
        />
      </Grid>
      <Grid item>
        <EmailInput control={control} label={`Email${required ? '*' : ''}`} required={required} />
      </Grid>
    </Grid>
  );
};

const ContactForm = ({
  question,
  onQuestionSubmit,
}: {
  question: IPolarisInterviewQuestion;
  onQuestionSubmit?: (index: number) => void;
}) => {
  const transition = useTransition();
  const isPolaris = useIsPolaris();

  const {
    control,
    handleSubmit,
    formState: { isDirty },
  } = useForm<IContactForm>({
    defaultValues: {
      phoneNumber: question?.answer?.phoneNumber || '',
      email: question?.answer?.email || '',
    },
  });

  /** This submit handler only fires when the data is valid */
  const onSubmit: SubmitHandler<IContactForm> = (data) => {
    onQuestionSubmit?.(question.index);

    transition({
      data: {
        value: data,
        question: {
          ...question,
          key: 'contact',
        },
        isPolaris,
      },
    });
  };

  return (
    <>
      <ContactFormInputFields control={control} />
      <SubmitButton onClick={handleSubmit(onSubmit)} text={isDirty ? 'Submit' : 'Skip'} />
    </>
  );
};

export default ContactForm;
